var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('multiselect',{attrs:{"value":_vm.value,"options":_vm.states,"multiple":true,"close-on-select":false,"placeholder":"Select state","label":"name","track-by":"id"},on:{"input":function($event){return _vm.valueChanged('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }